import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import Cookies from 'js-cookie';

// ================= constants
const TOKEN_COOKIE_NAME = 'auth-token';
const EXPIRATION_DAYS = 1;

// ================= cookie storage for token only
const tokenStorage = {
  getItem: (name) => {
    const token = Cookies.get(name);
    if (!token) return null;
    
    return JSON.stringify({ state: { token } });
  },
  setItem: (name, value) => {
    try {
      const parsed = JSON.parse(value);
      const token = parsed?.state?.token;
      
      if (token) {
        Cookies.set(name, token, {
          expires: EXPIRATION_DAYS,
          secure: process.env.NODE_ENV === 'production',
          sameSite: 'strict',
        });
      }
    } catch (err) {
      console.error('Failed to set token cookie:', err);
    }
  },
  removeItem: (name) => {
    Cookies.remove(name);
  },
};

// ============= Company Check =========
const checkIsIncludeCompany = (user) => {  
  return !!user && user.companyId !== null && user.companyId !== '';
};

// ================= Zustand store=========
export const useAuthStore = create(
  persist(
    (set, get) => ({
      token: null,
      user: null,
      isAuthenticated: false,
      isIncludeCompany: false,
      isUserLoaded: false,
      // ========= Actions =========
      setToken: (token) => {
        set({ token, isAuthenticated: !!token });
      },

      setUser: (user) => {
        const isIncludeCompany = checkIsIncludeCompany(user);
        
        set({ 
          user, 
          isIncludeCompany,
          isUserLoaded: !!user, 
        });
      },

      

      logout: () => {
        set({ 
          token: null, 
          user: null, 
          isAuthenticated: false,
          isIncludeCompany: false, 
          isUserLoaded: false,
        });
        checkIsIncludeCompany(null)
        Cookies.remove(TOKEN_COOKIE_NAME);
      },

      // ========= Derived state check =========
      checkAuth: () => !!get().token,
    }),
    {
      name: TOKEN_COOKIE_NAME,
      storage: createJSONStorage(() => tokenStorage),
      
      // ==========  token ==========
      partialize: (state) => ({
        token: state.token,
      }),
      
    
    }
  )
);

// ========= Hooks =========
export const useToken = () => useAuthStore((s) => s.token);
export const useUser = () => useAuthStore((s) => s.user);
export const useIsAuthenticated = () => useAuthStore((s) => s.isAuthenticated);
export const useIsIncludeCompany = () => useAuthStore((s) => s.isIncludeCompany); 
export const useIsUserLoaded = () => useAuthStore((s) => s.isUserLoaded);
// ========= Action Hooks =========
export const useSetToken = () => useAuthStore((s) => s.setToken);
export const useSetUser = () => useAuthStore((s) => s.setUser);
export const useLogout = () => useAuthStore((s) => s.logout);
export const useCheckAuth = () => useAuthStore((s) => s.checkAuth);